import { TReadMessagesResponse, fetchReadMessages } from '../repositories/cian-chat-bot/v1/read-messages';
import { TContext } from '../types/context';

const DEGRADATION_TELEMETRY_KEY = 'degradation.chatbotReadMessages';

export async function fetchChatbotReadMessages({ httpApi, logger, telemetry }: TContext): Promise<void> {
  try {
    const { statusCode, response }: TReadMessagesResponse = await fetchReadMessages({
      httpApi,
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      logger.warning('Невалидный ответ от сервера', {
        domain: 'src/shared/services/fetchChatbotReadMessages.ts',
        statusCode,
        message: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });
    }
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(error, {
      message: 'Не удалось пометить прочитанными сообщения чатбота',
      domain: 'src/shared/services/fetchChatbotReadMessages.ts',
    });
  }
}
